export default __webpack_public_path__ + "6e5bbcc71863256a7e17b7bf145b03d8.png";